import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-white-panel',
  imports: [],
  templateUrl: './white-panel.component.html',
  host: {
    class: 'flex flex-col bg-background-fixed dark:bg-background-container-primary rounded-radius-primary',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhitePanelComponent {}
